import { graphql } from "@/graphql/generated/gql";
import { DeleteMunicipalPropertyMutation, DeleteMunicipalPropertyMutationVariables } from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const DELETE_MUNICIPAL_PROPERTY_MUTATION_DOCUMENT: TypedDocumentNode<
  DeleteMunicipalPropertyMutation,
  DeleteMunicipalPropertyMutationVariables
> = graphql(/* GraphQL */ `
  mutation DeleteMunicipalProperty($id: ID!) {
    deleteMunicipalProperty(id: $id) { id archivedAt }
  }
`);
